import { Reducer } from 'redux';
import {
  AddTaskComment,
  DeleteTaskComment,
  DeleteTaskFile,
  FilterTasksList,
  GetTaskDetail,
  GetTasksList,
  initialTasksState,
  TTaskActions,
  TTasksState,
  UpdateTask,
  UploadTaskFile,
  SubmitConclusion,
} from '../types/Tasks';
import { endReducer } from '../store/Store';
import { filterTasks } from '../helpers/taskFilter';

const applyFilters = (state: TTasksState): TTasksState => ({
  ...state,
  filteredList: state.data
    ? filterTasks(
        state.data,
        state.searchPhrase || '',
        state.selectedStatuses || [],
        state.selectedPriorities || []
      )
    : undefined,
});

export const taskReducer: Reducer<TTasksState, TTaskActions> = (
  state = initialTasksState,
  action
) => {
  switch (action.type) {
    case GetTasksList.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GetTasksList.SUCCESS: {
      const newState = {
        ...state,
        loading: false,
        data: action.payload.data.tasks,
        statusOptions: action.payload.data.statusOptions,
        priorityOptions: action.payload.data.priorityOptions,
      };
      return applyFilters(newState);
    }

    case GetTasksList.FAILED:
      return {
        ...state,
        loading: false,
      };

    case FilterTasksList.SUBMIT:
      return applyFilters({
        ...state,
        searchPhrase: action.payload.search,
        selectedStatuses: action.payload.statuses,
        selectedPriorities: action.payload.priorities,
      });

    case GetTaskDetail.REQUEST:
      return {
        ...state,
        detailLoading: true,
      };

    case GetTaskDetail.SUCCESS:
      return {
        ...state,
        detailLoading: false,
        detail: action.payload.data,
      };

    case GetTaskDetail.FAILED:
      return {
        ...state,
        detailLoading: false,
      };

    case AddTaskComment.SUCCESS: {
      if (!state.detail) return state;
      return {
        ...state,
        detail: {
          ...state.detail,
          comments: [...state.detail.comments, action.payload.data],
        },
      };
    }

    case DeleteTaskComment.SUCCESS: {
      if (!state.detail) return state;
      const deletedCommentId = action.payload.data.commentId;
      return {
        ...state,
        detail: {
          ...state.detail,
          comments: state.detail.comments.filter(
            (c) => c.id !== deletedCommentId
          ),
        },
      };
    }

    case UploadTaskFile.SUCCESS: {
      if (!state.detail) return state;
      return {
        ...state,
        detail: {
          ...state.detail,
          files: [...state.detail.files, action.payload.data],
        },
      };
    }

    case DeleteTaskFile.SUCCESS: {
      if (!state.detail) return state;
      const deletedFileId = action.payload.data.fileId;
      return {
        ...state,
        detail: {
          ...state.detail,
          files: state.detail.files.filter((f) => f.id !== deletedFileId),
        },
      };
    }

    case UpdateTask.SUCCESS:
      if (action.payload.data.assigneeChanged) {
        return {
          ...state,
          detail: undefined,
        };
      }
      return {
        ...state,
        detail: action.payload.data,
      };

    case SubmitConclusion.REQUEST:
      return {
        ...state,
        detailLoading: true,
      };

    case SubmitConclusion.SUCCESS:
      return {
        ...state,
        detailLoading: false,
        detail: action.payload.data,
      };

    case SubmitConclusion.FAILED:
      return {
        ...state,
        detailLoading: false,
      };

    default:
      return endReducer(state, action);
  }
};
